import {
  Box,
  Card,
  Column,
  Columns,
  Divider,
  Heading,
  Stack,
  Text,
} from 'braid-design-system';
import React, { type ReactNode } from 'react';
import { shallowEqual, useSelector } from 'react-redux';

import { JobPrice } from 'src/app/v1/views/pages/MultiLocation/components/JobPrice';
import { locationIds } from 'src/app/v1/views/pages/MultiLocation/constants/multiLocation';
import type {
  LocationObject,
  LocationField,
  OrderTotals,
} from 'src/app/v1/views/pages/MultiLocation/type';
import type { AppState } from 'src/types/appState';

type SummaryItemProps = {
  title: ReactNode;
  value: ReactNode;
};

type OrderSummaryProps = {
  locationFields: Array<LocationField>;
  locations: LocationObject;
  orderTotals: OrderTotals;
};
const SummaryItem = ({ title, value }: SummaryItemProps) => (
  <Columns space="xlarge">
    <Column width="3/5">
      <Box>{title}</Box>
    </Column>
    <Column width="content">
      <Box>{value}</Box>
    </Column>
  </Columns>
);

export const MultiLocationOrderSummary = ({
  locationFields,
  locations,
  orderTotals,
}: OrderSummaryProps) => {
  const { hidePrice } = useSelector(
    (state: AppState) => ({
      hidePrice: state.session.hirerAccount?.hidePrice,
    }),
    shallowEqual,
  );

  return (
    <Card>
      <Stack space="medium">
        <Heading level="3">{'Order summary'}</Heading>
        <SummaryItem
          title={<Text weight="strong">Items</Text>}
          value={<Text weight="strong">Cost</Text>}
        />

        <Divider />

        {locationFields.map(
          ({ elementKey }, key) =>
            locations[locationIds[key]].jobLocationText !== undefined &&
            locations[locationIds[key]].jobLocationText !== '' && (
              <SummaryItem
                key={key}
                title={
                  <Text>{locations[locationIds[key]].jobLocationText}</Text>
                }
                value={
                  <JobPrice
                    id={elementKey}
                    jobPrice={locations[locationIds[key]].jobPrice}
                  />
                }
              />
            ),
        )}

        <Box
          style={{ marginLeft: -25, marginRight: -25, height: 92, padding: 25 }}
          background="neutralLight"
        >
          <SummaryItem
            title={<Text weight="strong">Subtotal</Text>}
            value={!hidePrice && <Text>{orderTotals.subTotal}</Text>}
          />
          <Box style={{ height: 20 }} />
          <SummaryItem
            title={<Text weight="strong">GST</Text>}
            value={<Text>{orderTotals.tax}</Text>}
          />
        </Box>

        <SummaryItem
          title={<Heading level="3">Total</Heading>}
          value={<Heading level="3">{orderTotals.total}</Heading>}
        />
      </Stack>
    </Card>
  );
};
